<div
  class="op-modal-banner"
  ngClass="op-modal-banner_{{ type }}"
  attr.data-test-selector="op-modal-banner-{{ type }}"
  >
  @if (type === 'info') {
    <svg info-icon size="small" class="hidden-for-mobile" />
  }
  @if (type === 'warning') {
    <svg alert-icon size="small" class="hidden-for-mobile" />
  }
  <p
    class="op-modal-banner--text spot-caption"
    >
    <span
      class="op-modal-banner--title spot-caption spot-caption_bold"
      [textContent]="title"
    ></span>
    <br/>
    <span
      class="op-modal-banner--subtitle hidden-for-mobile"
      [textContent]="subtitle"
    ></span>
  </p>

  @if (!!actionButton) {
    <button
      class="op-modal-banner--button button"
      type="button"
      (click)="buttonClicked.emit($event)"
      >
      <op-icon icon-classes="button--icon {{ actionButtonClasses }}" />
      <span class="button--text" [textContent]="actionButton"></span>
    </button>
  }
</div>
